import { html, nothing } from 'lit';

const stages = ['Schule wählen', 'Link anfordern', 'Bewerbung ausfüllen'] as const;

/** The three stages of an application. The current stage and everything before it are highlighted. */
export const RegistrationSteps = (current: 1 | 2 | 3) => html`
  <ol class="steps mx-auto w-full max-w-xl text-sm" aria-label="Ablauf der Bewerbung">
    ${stages.map(
      (label, index) => html`
        <li
          class="step ${index < current ? 'step-primary' : ''}"
          aria-current=${index + 1 === current ? 'step' : nothing}
        >
          ${label}
        </li>
      `,
    )}
  </ol>
`;
